import FMLLogo from '../assets/images/logo-FML.svg'
// import FalchionLog from '../assets/images/logo-icon.svg'
import FalchionLog from '../assets/images/myfxLogo.svg'
import { useNavigate } from 'react-router-dom'
const Logos = () => {
    const navigate = useNavigate();
    const handleMenuItemClick = () => {
        navigate('/home');
        document.body.classList.remove('menu-open');
    };
    return (

        <div className="border d-inline-flex border-secondary rounded-3 p-2 gap-3 border-opacity-50" onClick={handleMenuItemClick}>
            <img src={FalchionLog} alt="Falchion Logo" height={40} />
            {/* <img src={FMLLogo} alt="FML Logo" height={40} /> */}
        </div>
    );
};

export default Logos;
